import React from "react";
import { useNavigate } from "react-router-dom";
import { GitCompareArrows, X } from "lucide-react";
import { useCompare } from "@/context/CompareContext";

export default function CompareTray() {
  const { skus, clear } = useCompare();
  const navigate = useNavigate();
  if (skus.length === 0) return null;
  return (
    <div data-testid="compare-tray" className="fixed bottom-5 right-5 z-[55] flex items-center gap-3 rounded-full border border-olive/15 bg-ivory/95 p-2 pr-4 shadow-xl backdrop-blur">
      <button onClick={() => navigate("/compare")} className="flex items-center gap-2 rounded-full bg-olive px-5 py-2.5 text-sm font-semibold text-ivory">
        <GitCompareArrows className="h-4 w-4" /> قارن ({skus.length})
      </button>
      <button onClick={clear} className="text-ink/40 hover:text-palred"><X className="h-5 w-5" /></button>
    </div>
  );
}
